import { ContentLayout } from "@amzn/awsui-components-react";
import { useState } from "react";
import { MAP_PAGE_STYLE } from "../common/MapUtils";
import Layout from "../layout/Layout";
import MapErrorMessage from "./common/MapErrorMessage";
import MapActions from "./common/MapActions";
import MapLocationBar from "./common/MapLocationBar";
import MapViewerCanvas, { MapViewerCanvasProps } from "./common/MapViewerCanvas";
import MapLayers from "./common/MapLayers";
import { useMapStore } from "../../store/MapStore";

const MapViewer = () => {
    const modes = useMapStore((state) => state.modes);
    const [canvasProps, setCanvasProps] = useState<MapViewerCanvasProps>({
        style: { gridRowStart: 1, gridColumnStart: 1 }
    });
    return (
        <Layout>
            <ContentLayout>
                <div style={MAP_PAGE_STYLE}>
                    <div style={{ display: 'grid', width: '100%', height: '100%' }}>
                        <MapViewerCanvas {...canvasProps} ></MapViewerCanvas>
                        <MapLocationBar style={{ gridRowStart: 1, gridColumnStart: 1 }} />
                        <MapErrorMessage style={{ gridRowStart: 1, gridColumnStart: 1 }} />
                        {modes.layers === 'map-layers' && <MapLayers isRightMap={false} style={{ gridRowStart: 1, gridColumnStart: 1, zIndex:3 }}/>}
                        <div style={{ gridRowStart: 1, gridColumnStart: 1, zIndex:3, width: 'fit-content', height: 'fit-content' }}>
                            <MapActions hasRightMap={false} />
                        </div>
                    </div>
                </div>
            </ContentLayout>
        </Layout>)
}

export default MapViewer;